import { shallowRef } from 'vue'
import { get } from '../../../utils/index'

export function useTable({ columnUrl, columnTableCode, column }) {
  const columns = shallowRef([])

  const getData = async () => {
    if (column) {
      return column
    } else if (columnTableCode) {
      const [res] = await get(`${columnUrl}${columnTableCode}`)
      return res?.data
    } else {
      return []
    }
  }
  const getColumns = async () => {
    columns.value = await getData()
  }

  return {
    columns,
    getColumns,
  }
}
